export default [
  {
    'name': 'addSignature', // 签名上链
    'method': 'addSignature(bytes,bytes)',
    'methodId': 'c17c720a',
    'params': ['bytes', 'bytes']
  },
  {
    'name': 'approval', // 授权
    'method': 'approval(address)',
    'methodId': '9430b496',
    'params': ['address']
  },
  {
    'name': 'contractMap', // 查询上链时间
    'method': 'contractMap(bytes32)',
    'methodId': 'cac39a05',
    'params': ['bytes32']
  },
  {
    'name': 'transferOwnership', // 转移管理员
    'method': 'transferOwnership(address)',
    'methodId': 'f2fde38b',
    'params': ['address']
  },
  {
    'name': 'revoke', // 取消授权
    'method': 'revoke(address)',
    'methodId': '74a8f103',
    'params': ['address']
  }
]
